export default {
    locale_code: 'sv_SE',
    publication_viewer_shopping_list_label: 'Inköpslista',
    publication_viewer_shopping_list_clear_button: 'Rensa lista',
    publication_viewer_delete_crossed_out_button: 'Ta bort överstrukna objekt',
    publication_viewer_print_button: 'Skriva ut',
    publication_viewer_download_button: 'Ladda ner',
    publication_viewer_until_label: 'Till slut',
    publication_viewer_offer_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_menu_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_expires_in_days_label: '(Går ut om {{days}} dagar)',
    publication_viewer_valid_in_days_label: '(Gäller in {{days}} days)',
    publication_viewer_expired_label: '(Utgånget)',
    publication_viewer_pages_button: 'Sidor',
    publication_viewer_offers_button: 'Erbjudanden',
    publication_viewer_search_text: 'Sök',
    publication_viewer_currency: 'SEK',
    publication_viewer_hotspot_picker_header: 'Vilket erbjudande menade du?',
    publication_viewer_overview_button: 'Översikt',
    publication_viewer_close_label: 'Tillbaka',
    publication_viewer_add_to_shopping_list: 'Lägg till inköpslista',
    publication_viewer_visit_webshop_link: 'Besök webbshoplänk',
    publication_viewer_upcoming: 'Kommende',
    publication_viewer_offer_price_from: 'Från',
    publication_viewer_offer_price_for: 'för',
    publication_viewer_offer_valid_from: 'Gäller endast fr.o.m ',
    publication_viewer_no_product_message: 'Inga produktdetaljer',
    publication_viewer_offer_increase_quantity: 'Öka antal',
    publication_viewer_offer_decrease_quantity: 'Minska antal'
};
